import _ from 'lodash';
import { routes } from '../api/routes';

const initialState = {
	accountNumber: '',
	accountDetailProgress: false,
	accountDetail: null,

	zipCode: '',
	zipCodeProgress: false,
	zipCodeDetail: null,
	productLine: '',
	productResultAvailability: null,
	productResultPrices: null,
	resultLoaded: false,
	// TO DO: Static list
	productLineList: [
		{"name":"Cooktops","categoryId":"882"},
		{"name":"Dehumidifiers","categoryId":"129" },
		{"name":"Dishwashers","categoryId":"844" },
		{"name":"Disposers & Compactors","categoryId":"845" },
		{"name":"Freezers","categoryId":"830" },
		{"name":"Icemakers","categoryId":"835" },
		{"name":"Microwave Ovens","categoryId":"884"},
		{"name":"Ranges","categoryId":"885" },
		routes.hvac,
		{"name":"Refrigerators","categoryId":"821" },
		{"name":"Room Air Conditioners","categoryId":"867" },
		{"name":"Speedcooking Ovens","categoryId":"886" },
		{"name":"Venting Systems & Hoods","categoryId":"887" },
		{"name":"Wall Ovens","categoryId":"888" },
		{"name":"Warming Drawers","categoryId":"889" },
		{"name":"Washers & Dryers","categoryId":"841" },
		{"name":"Water Filters & Softeners","categoryId":"868" },
		{"name":"Water Heaters","categoryId":"3577" },
		{"name":"Wine Reserves & Beverage Centers","categoryId":"836" },
		{"name":"Small Appliances", "categoryId":"3608"},
		{"name":"SmartHome Solutions", "categoryId":"3697"}
	],
	productLineFilters: null,
	productNumberKeywordResult: null,
	isValidProductNumber: true,
	showSuggestion: false,

	productSpecs: null,

	narrowYourResultSelectedValue: null,
	productLineNarrowYourResultsFilter: null,
	isProductAvailabilityCallCompleted: false,

	numberOfParallelCallForProductPrices: 0,
	numberCompletedOfParallelCallForProductPrices: null,

	totalNumberOfRecords: null,
	fromWhere: null,
	adcData: []
};

export default function product(state = initialState, action) {
    switch (action.type) {
		case 'SAVE_ADC':
			const adcData = state.adcData;
			adcData.push(action.data);
			return { ...state,
				adcData
			};
		case 'SAVE_PRODUCT_RESULT_AVAILABILITY':
			let productResultAvailability = state.productResultAvailability || [];
			productResultAvailability = productResultAvailability.concat(action.data.responseObject);
			productResultAvailability = _.uniqBy(productResultAvailability, 'sku');
			productResultAvailability = _.sortBy(productResultAvailability, 'sku');
			productResultAvailability.map((item, index) => {
				var record = _.find(state.productNumberKeywordResult, ['sku', item.sku]);
				if(record) {
					item.description = record.description;
					item.quickSpecPdfName = record.quickSpecPdfName;
					item.finalProductionDate = record.finalProductionDate;
					item.firstDistributionDate = record.firstDistributionDate;
					item.msrp = record.msrp;
					item.brand = record.brand;
					item.category = record.category;
					item.smallAppliance = record.smallAppliance;
					item.imagePath = record.imagePath;
					item.quickSpecPdfPath = record.quickSpecPdfPath;
					item.overpackQuantityRequired = record.overpackQuantityRequired;
					item.packageQuantity = record.packageQuantity;
				}
				return null
			});
			return { ...state,
				productResultAvailability: productResultAvailability
			};
		case 'UPDATE_AVAILABILITY_FOR_PRE_LOGIN':
			let productNumberKeywordResult2 = state.productNumberKeywordResult;
			productNumberKeywordResult2.map((item, index) => {
				var record = _.find(state.productResultAvailability, ['sku', item.sku]);
				if(record) {
					item.availableQty = record.availableQty;
					item.etaDate = record.etaDate;
					item.intransitQty = record.intransitQty;
				}
				return null;
			})
			return { ...state,
				productNumberKeywordResult: productNumberKeywordResult2
			}
		case 'UPDATE_AVAILABILITY_WITH_PRICES_AND_DISCOUNTS':
			const productResultAvailability1 = state.productResultAvailability;
			let finalData = [];
			productResultAvailability1 && productResultAvailability1.forEach(item => {
				const itemPriceRecord = _.find(state.productResultPrices, {'item_number': item.sku});
				if(itemPriceRecord && itemPriceRecord.records.length > 0) {
					const priceRecord = JSON.parse(JSON.stringify(itemPriceRecord.records));
					const unitPrice = priceRecord[0].unit_price ? priceRecord[0].unit_price : '',
						adjUnitPrice = priceRecord[0].adjusted_unit_price ? priceRecord[0].adjusted_unit_price : '',
						closeout = priceRecord[0].net_net_closeout_ind === "Y"?true:false,
						netNet = priceRecord[0].net_net_closeout_ind === "P" || priceRecord[0].net_net_closeout_ind === "E"?true:false;

					// get 5 discounts and update object
					let priceRecordForDiscounts = JSON.parse(JSON.stringify(itemPriceRecord.records));
					if(itemPriceRecord.records[0].dtl_stg_operand_calc_code === 'NEWPRICE') {
						priceRecordForDiscounts = [];
						itemPriceRecord.records.forEach((it, indx) => {
							if(indx !== 0) {
								priceRecordForDiscounts.push(it);
							}
						});
					}
					let pts = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - PLAN TO SELL' });
					pts = pts ? pts.dtl_stg_adjusted_amt : '';
					priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - PLAN TO SELL' }], 'modifier_price_subtype');

					let groupPA = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - GROUP PRICE ADJUSTMENT' });
					groupPA = groupPA ? groupPA.dtl_stg_adjusted_amt : '';
					priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - GROUP PRICE ADJUSTMENT' }], 'modifier_price_subtype');

					let draft = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - DRAFT' });
					draft = draft ? draft.dtl_stg_adjusted_amt : '';
					priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - DRAFT' }], 'modifier_price_subtype');

					let pvr = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - VOLUME REBATE' });
					pvr = pvr ? pvr.dtl_stg_adjusted_amt : '';
					priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - VOLUME REBATE' }], 'modifier_price_subtype');

					let other = 0;
					priceRecordForDiscounts.forEach(itm => {
						if(itm.dtl_stg_adjusted_amt) {
							other += parseFloat(itm.dtl_stg_adjusted_amt);
						}
					});
					finalData.push({
						...item,
						price: unitPrice ? unitPrice.replace("-","") : "",
						netPrice: adjUnitPrice ? adjUnitPrice.replace("-","") : "",
						pts: pts ? pts.replace("-","") : "",
						groupPA: groupPA ? groupPA.replace("-","") : "",
						other: other === 0 ? '' : other.toString().replace("-",""),
						draft: draft ? draft.replace("-","") : "",
						pvr: pvr ? pvr.replace("-","") : "",
						closeout,
						netNet
					});
				}

				if(item.replacementList && item.replacementList.length) {
					const replacementList = [];
					item.replacementList.forEach(itm => {
						const itemPriceRecord = _.find(state.productResultPrices, {'item_number': itm.sku});
						if(itemPriceRecord && itemPriceRecord.records.length > 0) {
							const priceRecord = JSON.parse(JSON.stringify(itemPriceRecord.records));
							const unitPrice = priceRecord[0].unit_price ? priceRecord[0].unit_price : '',
								adjUnitPrice = priceRecord[0].adjusted_unit_price ? priceRecord[0].adjusted_unit_price : '',
								closeout = priceRecord[0].net_net_closeout_ind === "C"?true:false,
								netNet = priceRecord[0].net_net_closeout_ind === "P" || priceRecord[0].net_net_closeout_ind === "E"?true:false;

							// get 5 discounts and update object
							let priceRecordForDiscounts = JSON.parse(JSON.stringify(itemPriceRecord.records));
							if(itemPriceRecord.records[0].dtl_stg_operand_calc_code === 'NEWPRICE') {
								priceRecordForDiscounts = [];
								itemPriceRecord.records.forEach((it, indx) => {
									if(indx !== 0) {
										priceRecordForDiscounts.push(it);
									}
								});
							}
							let pts = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - PLAN TO SELL' });
							pts = pts ? pts.dtl_stg_adjusted_amt : '';
							priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - PLAN TO SELL' }], 'modifier_price_subtype');

							let groupPA = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - GROUP PRICE ADJUSTMENT' });
							groupPA = groupPA ? groupPA.dtl_stg_adjusted_amt : '';
							priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - GROUP PRICE ADJUSTMENT' }], 'modifier_price_subtype');

							let draft = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - DRAFT' });
							draft = draft ? draft.dtl_stg_adjusted_amt : '';
							priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - DRAFT' }], 'modifier_price_subtype');

							let pvr = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - VOLUME REBATE' });
							pvr = pvr ? pvr.dtl_stg_adjusted_amt : '';
							priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - VOLUME REBATE' }], 'modifier_price_subtype');

							let other = 0;
							priceRecordForDiscounts.forEach(it => {
								if(it.dtl_stg_adjusted_amt) {
									other += parseFloat(it.dtl_stg_adjusted_amt);
								}
							});
							replacementList.push({
								...itm,
								price: unitPrice ? unitPrice.replace("-","") : "",
								netPrice: adjUnitPrice ? adjUnitPrice.replace("-","") : "",
								pts: pts ? pts.replace("-","") : "",
								groupPA: groupPA ? groupPA.replace("-","") : "",
								other: other === 0 ? '' : other.toString().replace("-",""),
								draft: draft ? draft.replace("-","") : "",
								pvr: pvr ? pvr.replace("-","") : "",
								closeout,
								netNet
							});
						}
					});
					finalData[finalData.length - 1].replacementList = replacementList;
				}
			});
			return { ...state,
				productResultAvailability: finalData,
				resultLoaded: true
			}
		case 'SAVE_PRODUCT_RESULT_PRICES':
			var productResultPrices = state.productResultPrices || [];
			const data = action.data.responseObject.items ? action.data.responseObject.items : [];
			data.forEach(item => {
				item.records = _.filter(item.records, {orderable: "Y"});
			});
			productResultPrices = productResultPrices.concat(data);
			return { ...state,
				productResultPrices: productResultPrices
			};
		case 'SAVE_NUMBER_OF_RECORDS':
			return { ...state,
				totalNumberOfRecords: action.data
			}
		case 'UPDATE_FROM_WHERE_PRODUCT_LINE_CLICKED':
			return { ...state,
				fromWhere: action.data
			}
	    case 'SAVE_PRODUCT_SPECS':
	        return { ...state,
	            productSpecs: action.data
	        };
	    case 'SAVE_PRODUCT_LINE':
	        return {
	            ...state,
	            productLine: action.data
	        };
		case 'SAVE_NARROW_YOUR_RESULT_SELECTED_VALUE':
			return {
				...state,
				narrowYourResultSelectedValue: action.data
			};
	    case 'SAVE_PRODUCT_LINE_FILTERS':
			var filters = null;
			if(action.data) {
				//Club all filters by displayName
				filters = _.unionBy(action.data.attributes, 'displayName');
				//Check duplicate and club all values from it
				action.data.attributes.map((item, index) => {
					filters.map((itm, inx) => {
						if(itm.displayName === item.displayName) {
							item.values.map((it, id) => {
								var check = _.find(itm.values, ['value', it.value]);
								if(!check) {
									itm.values.push(it)
								}
								return null;
							})
						}
						return null;
					});
					return null;
				});
				filters = _.pullAllBy(filters, [{ 'displayName': 'CustomerNet' }], 'displayName');
				//Exclude CustomerNet.CloseoutIndicator filter from filters
				filters = _.pullAllBy(filters, [{ 'name': 'CustomerNet.CloseoutIndicator' }], 'name');
	            action.data = {
					selectedFilters: action.data.selectedAttribs,
					filters: filters
				};
			}
			//Check if existing filters available or not
			filters = state.productLineFilters;
			if(state.productLineFilters && action.data) {
				//Add disable where it is not available
				var existingFilters = action.data?_.filter(action.data.selectedFilters, ['leaf', true]):[],
					filterString = "";
				existingFilters.map((item, index) => {
					filterString = filterString + "+" + item.id
					return "";
				});
				filters.filters.map((item, index) => {
					var temp = _.find(action.data.filters, ['displayName', item.displayName]);
					item.values.map((it, id) => {
						it.disable = true;
						it.checked = false;	// reset default false
						var checkSelected = _.find(existingFilters, ["name", it.value]);
						//Comparing selected dropdown value in case of not checked
						if(!checkSelected && state.narrowYourResultSelectedValue && state.narrowYourResultSelectedValue.label.indexOf(it.value) !== -1) {
							checkSelected = true;
						}
						if(checkSelected) {
							it.disable = false;
							it.checked = true;	//Set in case it was already selected
						}
						return null;
					});

					if(temp) {
						temp.values.map((itm, ind) => {
							item.values.map((it, id) => {
								if(it.value === itm.value && it.checked === false) {
									it.dimensionId = itm.dimensionId;
									it.disable = false;
								}
								return null;
							});
							return null;
						});
					}
					return null;
				});
				filters.selectedFilters = action.data.selectedFilters
			} else {
				filters = action.data;
			}
	        return { ...state,
	            productLineFilters: filters
	        };
		case 'SAVE_PRODUCT_LINE_NARROW_YOUR_RESULTS_FILTERS':
			action.data = action.data && action.data.responseObject?action.data.responseObject.children:null;
			var productLineNarrowYourResultsFilter = [];
			action.data && action.data.map((item, index) => {
				productLineNarrowYourResultsFilter.push(item);
				return null;
			});
	        return { ...state,
	            productLineNarrowYourResultsFilter: productLineNarrowYourResultsFilter,
	        };
	    case 'SHOW_HIDE_AUTO_SELECT':
	        return { ...state,
	            showSuggestion: action.data
	        };
	    case 'RESET_PRODUCT_NUMBER_KEYWORD_RESULT_LIST':
	        return { ...state,
	            productNumberKeywordResult: null
	        }
		case 'RESET_PRODUCT_AVAILABILITY_RESULT_LIST':
	        return { ...state,
				productResultAvailability: null
	        }
		case 'RESET_PRODUCT_PRICE_RESULT_LIST':
	        return { ...state,
				productResultPrices: null
	        }
		case 'RESET_RESULT_LOADED':
			return { ...state,
				resultLoaded: false
			}
	    case 'SAVE_PRODUCT_NUMBER_KEYWORD_RESULT_LIST':
			var productNumberKeywordResult = state.productNumberKeywordResult || [];
			productNumberKeywordResult = productNumberKeywordResult.concat(action.data.responseObject);
			productNumberKeywordResult = _.uniqBy(productNumberKeywordResult, 'sku');
			productNumberKeywordResult = _.sortBy(productNumberKeywordResult, 'sku');
			productNumberKeywordResult.map((item, index) => {
				if(item.price) {
					item.price = parseFloat(item.price);
				}
				return null;
			})
			return { ...state,
				productNumberKeywordResult: productNumberKeywordResult
			}
		case 'UPDATE_PRODUCT_NUMBER_KEYWORD_RESULT_LIST':
			var productNumberKeywordResult1 = state.productNumberKeywordResult || [];
			productNumberKeywordResult1.map((item, index) => {
				let record = _.find(action.data.responseObject, ['sku', item.sku]);
				if(record) {
					item.availableQty = record.availableQty;
					item.etaDate = record.etaDate;
					item.intransitQty = record.intransitQty;
				}
				return null;
			})
			return { ...state,
				productNumberKeywordResult: productNumberKeywordResult1
			}
	    case 'SAVE_ACCOUNT_NUMBER':
	        return { ...state,
	            accountNumber: action.data
	        };
	    case 'SAVE_ACCOUNT_DETAIL':
	        return { ...state,
	            accountDetail: action.data
	        };
	    case 'SHOW_ACCOUNT_DETAIL_PROGRESS':
	        return { ...state,
	            accountDetailProgress: action.data
	        };
	    case 'SAVE_ZIP_CODE_DETAILS':
	        return { ...state,
	            zipCodeDetail: action.data
	        };
	    case 'SHOW_ZIP_CODE_PROGRESS':
	        return { ...state,
	            zipCodeProgress: action.data
	        };
	    case 'SAVE_ZIP_CODE':
	        return { ...state,
	            zipCode: action.data
	        };
		case 'SAVE_PRODUCT_AVAILABILITy_CALL_COMPLETED':
			return { ...state,
				isProductAvailabilityCallCompleted: action.data
			}
		case 'SAVE_NUMBER_OF_PARALLEL_CALL_FOR_PRODUCT_PRICES':
			return { ...state,
				numberOfParallelCallForProductPrices: action.data,
				numberCompletedOfParallelCallForProductPrices: null
			}
		case 'SAVE_COMPLETED_NUMBER_OF_PARALLEL_CALL_FOR_PRODUCT_PRICES':
			let noOfCompletedCalls2 = state.numberCompletedOfParallelCallForProductPrices || 0;
			noOfCompletedCalls2 += 1;
			return { ...state,
				numberCompletedOfParallelCallForProductPrices: noOfCompletedCalls2
			}
		case 'RESET_PRODUCT_REDUCERS':
			return initialState;
		case 'SAVE_PARTS_SEARCH_RESULT':
			return {...state,
				partsSearchResult: {
					...(state.partsSearchResult || {}),
					...action.data
				}
			};
		case 'CLEAR_PARTS_SEARCH_RESULT':
			return {
				...state,
				partsSearchResult: null
			}
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/product.js